import { Pivot, PivotItem } from "@fluentui/react";
import AssetDetails from "./AssetDetails";
import AssetHierarchy from "./AssetHierarchy";
import AssetIssues from "./AssetIssues";
import { useLocation } from "react-router-dom";

const Asset = () => {
    const query = new URLSearchParams(useLocation().search);
    const assetId = Number.parseInt(query.get("id") ?? "");

    return (
        <Pivot defaultSelectedKey="fields">
            <PivotItem headerText="Fields" itemKey="fields">
                <AssetDetails assetId={assetId} />
            </PivotItem>
            <PivotItem headerText="Issues" itemKey="issues">
                <AssetIssues assetId={assetId} />
            </PivotItem>
            <PivotItem headerText="Hierarchy" itemKey="hierarchy">
                <AssetHierarchy assetId={assetId} />
            </PivotItem>
        </Pivot>
    );
};

export default Asset;
